import classNames from "classnames/bind";
import {GatsbyImage, getImage} from "gatsby-plugin-image";
import * as React from "react";
import ReactPlayer from "react-player/lazy";
import * as mediaStyles from "./media.module.css";

const cx = classNames.bind(mediaStyles);

const Media = ({media, big, imageProps, className, plainImage}) => {
    const getMedia = () => {
        if (!media) {
            return <div className={cx({media: true}, className)} />;
        }

        if (media.content) {
            const isVideo = media.content.mime?.indexOf("video/") === 0;
            if (isVideo) {
                return (
                    <div className={mediaStyles.media__playerWrapper}>
                        <ReactPlayer
                            className={mediaStyles.media__player}
                            url={media.content.url}
                            height="100%"
                            width="100%"
                            playsinline
                            muted
                            playing
                            loop
                        />
                    </div>
                );
            }

            const image = !isVideo && getImage(media.content.localFile);
            if (image) {
                if (plainImage) {
                    const fallback = image.images?.fallback;
                    const sources = image.images?.sources || [];

                    return (
                        <picture className={className}>
                            {sources.map(({type, srcSet}) => (
                                <source key={type} type={type} srcSet={srcSet} />
                            ))}

                            <img
                                src={fallback?.src}
                                srcSet={fallback?.srcSet}
                                alt=""
                                {...imageProps}
                                className={imageProps?.imgClassName}
                            />
                        </picture>
                    );
                }

                return <GatsbyImage alt="" image={image} {...imageProps} className={className} />;
            }

            const rawImageProps =
                (media.content.width || media.content.localFile?.width) !== undefined
                    ? {
                          width: media.content.width || media.content.localFile?.width,
                          height: media.content.height || media.content.localFile?.height,
                          style: {maxWidth: `${media.content.width || media.content.localFile?.width}px`},
                      }
                    : {};

            const isSVG = (media.content.mime || media.content.localFile?.mime) === "image/svg+xml";
            if (!isSVG) {
                return (
                    <div className={cx({media: true}, className)}>
                        <img
                            className={cx({[mediaStyles.media__image]: true})}
                            src={media.content.localFile?.publicURL}
                            alt=""
                            {...rawImageProps}
                        />
                    </div>
                );
            }

            const aspectRatio = `${(rawImageProps.height / rawImageProps.width) * 100}%`;

            return (
                <div
                    className={cx({media: true, [mediaStyles.media_svg]: true}, className)}
                    style={{"--aspect-ratio": aspectRatio}}
                >
                    <div>
                        <img
                            className={cx({
                                [mediaStyles.media__image]: true,
                                [imageProps?.imgClassName]: imageProps?.passClassToSVG,
                            })}
                            src={media.content.localFile?.publicURL}
                            alt=""
                            width={rawImageProps.width}
                            height={rawImageProps.height}
                        />
                    </div>
                </div>
            );
        }

        if (!media.youtubeVideoURL) {
            return <div className={cx({media: true}, className)} />;
        }

        if (media.youtubeVideoURL.startsWith("http")) {
            return (
                <div className={cx({media: true}, className)}>
                    <div className={cx({media__playerWrapper: true, media__playerWrapper_big: big})}>
                        <ReactPlayer
                            className={mediaStyles.media__player}
                            url={media.youtubeVideoURL?.trim()}
                            light
                            playsinline
                            playing
                            height="100%"
                            width="100%"
                        />
                    </div>
                </div>
            );
        }

        return (
            <div className={cx({media: true}, className)}>
                <div className={cx({media__playerWrapper: true, media__playerWrapper_big: big})}>
                    <div
                        className={cx({media__frame: true})}
                        dangerouslySetInnerHTML={{__html: media.youtubeVideoURL}}
                    />
                </div>
            </div>
        );
    };

    return getMedia();
};

export default Media;
